import { Availibilities, Availibility, AvailibilitySlot, MeetMethod, StoredShopData } from "../../../components/booking/types";
import { getUserData } from '../../../helpers/user'
import { AlpineComponentTryba } from '../../alpine/include/global';
// import {SimpleCheckChoice} from "../../scripts/forms/quotation-form/types";

interface BookingFormAlpine extends AlpineComponentTryba {
    storedShopData: StoredShopData;
    shopCodeState: string | null;
    meetMethod: MeetMethod | null;
    currentDateState: Date;
    currentPageState: number;
    formattedDate: string | null;
    formattedDateRecapState: string | null;
    meetHoursUrlState: string;
    availabilitiesState: Availibilities | null;
    limitState: number;
    loadingMeethoursState: boolean;
}

let storeLocalAvailabilities;
let storeLocalShopCode;

function initMeetHoursComponent(fromAbTest: string | null = null) {
    const initMeetHoursLogic: BookingFormAlpine = {
        isFromAbTest: fromAbTest == 'fromAbTest' ? true : false,
        storedShopData: [],
        shopCodeState: null,
        meetMethod: null,
        currentDateState: new Date(),
        currentPageState: 1,
        formattedDate: null,
        formattedDateRecapState: null,
        meetHoursUrlState: '/api/espace-conseil/disponibilites/',
        shopPhoneState: '03 88 43 00 20',
        availabilitiesState: null,
        limitState: 3,
        loadingMeethoursState: false,
        displayPrevArrow: false,
        slotStepState: 0,
        localAvailabilities: null,
        city: null,
        hourChoicesState: [] as Array<string>,
        initBookingFormFct(): void {
            if (window.localStorage.getItem('ab-quick-meethours-prettySlot') && window.localStorage.getItem('ab-quick-meethours-slot') && /demande-de-rendez-vous/.test(window.location.href) && this.nextStep !== undefined) {
                setTimeout(() => {
                    this.prevSteps.push(this.step);
                    this.nextStepKey = this.step.fieldsNextStep;
                    this.nextStep();

                    window.localStorage.removeItem('ab-quick-meethours')
                    window.localStorage.removeItem('ab-quick-meethours-prettySlot')
                    window.localStorage.removeItem('ab-quick-meethours-slot')
                }, 500);
            } else {
                if (this.isFromAbTest) {
                    // Bg color of section
                    document.querySelector('.express_appointment_form')?.querySelector('.left-0')?.classList.add('!h-full');
                    this.loadingMeethoursState = true;
                    this.dateFormationFct();
                    const userData = getUserData();
                    if (userData && userData.shop) {
                        this.shopCodeState = userData.shop.clientNumber;
                        if (userData.shop.city) {
                            this.city = userData.shop.city;
                        }
                        if (userData.shop.phone) {
                            this.shopPhoneState = userData.shop.phone;
                        }
                    }
                    this.getAvailabilitiesFct();
                } else {
                    if (this.step.name == 'availability') {
                        this.loadingMeethoursState = true;
                        //Formatted current Date
                        this.dateFormationFct();
                        //Get reservation type
                        // if (this.arrayChoice[1] == 'À domicile') {
                            this.meetMethod = 'home';
                        // }
                        //Get city of the selected store
                        const userData = getUserData();
                        if (userData && userData.shop) {
                            this.shopCodeState = userData.shop.clientNumber;
                            if (userData.shop.phone) {
                                this.shopPhoneState = userData.shop.phone;
                            }
                        }
                        this.getAvailabilitiesFct();
                    } else {
                        this.prevSteps.forEach((item) => {
                            if (item.name == 'availability') {
                                this.availabilitiesState = storeLocalAvailabilities
                            }
                        })
                    }
                }
            }
        },
        async getAvailabilitiesFct(): Promise<void> {
            this.loadingMeethoursState = true;
            if (!this.$store.global.isMobile) {
                if (this.isFromAbTest) {
                    this.limitState = 7;
                } else {
                    this.limitState = 5;
                }
            }
            //Api call to get store availabilitiesState about meetmethod, date and store selected
            const newUrl = `${this.meetHoursUrlState}?start=${this.formattedDate}&meetMethod=${this.meetMethod}&limit=${this.limitState}&page=${this.currentPageState}`;
            const response = await fetch(newUrl);
            if (!response.ok) {
                throw new Error(response.statusText);
            }
            const data = await response.json();
            this.loadingMeethoursState = false;
            this.availabilitiesState = data;
            storeLocalAvailabilities = data
            storeLocalShopCode = this.shopCodeState

            if (this.choice) {
                this.hasChoiceFct();
            }
        },
        async getShopPhone(): Promise<void> {
            const response = await fetch(`/api/espace-conseil/phone/${this.shopCodeState}`);
            if (!response.ok) {
                throw new Error(response.statusText);
            }
            this.shopPhoneState = await response.text();
        },
        hasChoiceFct(): void {
            Object.entries(this.availabilitiesState as Availibilities).forEach((availibility: [string, Availibility]) => {
                Object.entries(availibility[1].slots).forEach((slot: [string, AvailibilitySlot]) => {
                    if (this.choice.from && this.choice.from.date === slot[1].from.date || !this.choice.from && this.choice.value === slot[1].value) {
                        slot[1].active = true;
                    }
                });
            });
        },
        handleClickSlotPrevStep(slot: AvailibilitySlot, item: AvailibilitySlot) {
            this.prevSteps.forEach((item) => {
                if (item.name == 'availability') {
                    this.step = item
                }
            })
            //Reset slots
            Object.entries(this.availabilitiesState as Availibilities).forEach((availibility: [string, Availibility]) => {
                Object.entries(availibility[1].slots).forEach((slot: [string, AvailibilitySlot]) => {
                    if (this.choice.from && this.choice.from.date === slot[1].from.date || !this.choice.from && this.choice.value === slot[1].value) {
                        slot[1].active = false;
                    }
                });
            });
            //Set loading true
            this.loading = true;
            //Delete slot already selected
            if (this.arrayChoice[2]) {
                this.arrayChoice.pop();
            }
            //Get stepChoice object
            this.choice = slot;
            //Format for recap
            if (this.choice.from) {
                const date = new Date(this.choice.from.date);
                const dataDayRecap = date.toLocaleDateString('default', { day: '2-digit' });
                const dataMonthRecap = date.toLocaleDateString('default', { month: 'long' });
                const dataYearRecap = date.toLocaleDateString('default', { year: 'numeric' });
                const dataHourRecap = date.getHours().toString().padStart(2, '0');
                const dataMinutesRecap = date.getMinutes().toString().padStart(2, '0');
                this.formattedDateRecapState = `${dataDayRecap} ${dataMonthRecap} ${dataYearRecap} - ${dataHourRecap}:${dataMinutesRecap}`;
                //Prepare form data
                this.dataChoice[this.step.name] = this.choice.from.date;
            } else {
                const dataDayRecap = item.date
                const dataMonthRecap = item.month
                this.formattedDateRecapState = `${dataDayRecap} ${dataMonthRecap} - ` + this.choice.prettySlot
                //Prepare form data
                this.dataChoice[this.step.name] = this.choice.value;
            }
            //Make choice as active
            this.choice.active = true;
            //Push in array the choice
            this.arrayChoice[this.step.name] = this.formattedDateRecapState;
            //Prepare form data
            // this.dataChoice[this.step.name] = this.choice.from.date;
            //Get next step key
            this.nextStepKey = this.step.fieldsNextStep;
            //Delete in prevSteps, arrayChoice and dataChoice all infos after actual step
            const targetName = this.step.name;
            const targetIndex = this.prevSteps.findIndex((obj) => obj.name === targetName);
            if (targetIndex !== -1) {
                this.prevSteps.splice(targetIndex + 1);
            }
            let foundArrayChoice = false;
            for (const key in this.arrayChoice) {
                if (foundArrayChoice) {
                    delete this.arrayChoice[key];
                }
                if (key === targetName) {
                    foundArrayChoice = true;
                }
            }

            let foundDataChoice = false;
            for (const key in this.dataChoice) {
                if (foundDataChoice) {
                    delete this.dataChoice[key];
                }
                if (key === targetName) {
                    foundDataChoice = true;
                }
            }
            //Go next step
            setTimeout(() => {
                this.nextStep(targetIndex + 1);
            }, 200);
        },
        handleClickSlotFct(slot: AvailibilitySlot, item: AvailibilitySlot) {
            this.choice = slot

            //Reset slots
            Object.entries(this.availabilitiesState as Availibilities).forEach((availibility: [string, Availibility]) => {
                Object.entries(availibility[1].slots).forEach((slot: [string, AvailibilitySlot]) => {
                    if (this.choice) {
                        slot[1].active = false;
                    }
                });
            });

            // Make and formatted the choice
            if (this.choice.from) {
                const date = new Date(this.choice.from.date);
                const dataDayRecap = date.toLocaleDateString('default', { day: '2-digit' });
                const dataMonthRecap = date.toLocaleDateString('default', { month: 'long' });
                const dataYearRecap = date.toLocaleDateString('default', { year: 'numeric' });
                const dataHourRecap = date.getHours().toString().padStart(2, '0');
                const dataMinutesRecap = date.getMinutes().toString().padStart(2, '0');
                this.formattedDateRecapState = `${dataDayRecap} ${dataMonthRecap} ${dataYearRecap} - ${dataHourRecap}:${dataMinutesRecap}`;
            } else {
                const dataDayRecap = item.date
                const dataMonthRecap = item.month
                const dataYearRecap = item.year
                this.formattedDateRecapState = `${dataDayRecap} ${dataMonthRecap} ${dataYearRecap} - ` + this.choice.prettySlot
            }
            this.choice.active = true;

            if (this.hourChoicesState.length == 0) {
                this.hourChoicesState.push(this.formattedDateRecapState);
            } else {
                this.hourChoicesState.pop();
                this.hourChoicesState.push(this.formattedDateRecapState);
            }

            // if (this.isFromAbTest) {
            //     //Get stepChoice object
            //     this.choice = slot;
            //     //Format for recap
            //     if (this.choice.from) {
            //         let date = new Date(this.choice.from.date);
            //         const dataDayRecap = date.toLocaleDateString('default', { day: '2-digit' });
            //         const dataMonthRecap = date.toLocaleDateString('default', { month: 'long' });
            //         const dataYearRecap = date.toLocaleDateString('default', { year: 'numeric' });
            //         const dataHourRecap = date.getHours().toString().padStart(2, '0');
            //         const dataMinutesRecap = date.getMinutes().toString().padStart(2, '0');
            //         this.formattedDateRecapState = `${dataDayRecap} ${dataMonthRecap} ${dataYearRecap} - ${dataHourRecap}:${dataMinutesRecap}`;
            //         //Prepare form data
            //         // this.dataChoice[this.step.name] = this.choice.from.date;
            //     } else {
            //         const dataDayRecap = item.date
            //         const dataMonthRecap = item.month
            //         const dataYearRecap = item.year
            //         this.formattedDateRecapState = `${dataDayRecap} ${dataMonthRecap} ${dataYearRecap} - ` + this.choice.prettySlot
            //         //Prepare form data
            //         // this.dataChoice[this.step.name] = this.choice.value;
            //     }
            //     window.localStorage.setItem('ab-quick-meethours-prettySlot', this.formattedDateRecapState);
            //     window.localStorage.setItem('ab-quick-meethours-slot', this.choice.value);
            //     window.location.href = `/demande-de-rendez-vous/#etape2`
            // } else {
            //     if (this.step.type == 'availability') {
            //         //Set loading true
            //         this.loading = true;
            //         //Delete slot already selected
            //         // if (this.arrayChoice[2]) {
            //         //     this.arrayChoice.pop();
            //         // }
            //         //Get stepChoice object
            //         this.choice = slot;
            //         //Format for recap
            //         if (this.choice.from) {
            //             let date = new Date(this.choice.from.date);
            //             const dataDayRecap = date.toLocaleDateString('default', { day: '2-digit' });
            //             const dataMonthRecap = date.toLocaleDateString('default', { month: 'long' });
            //             const dataYearRecap = date.toLocaleDateString('default', { year: 'numeric' });
            //             const dataHourRecap = date.getHours().toString().padStart(2, '0');
            //             const dataMinutesRecap = date.getMinutes().toString().padStart(2, '0');
            //             this.formattedDateRecapState = `${dataDayRecap} ${dataMonthRecap} ${dataYearRecap} - ${dataHourRecap}:${dataMinutesRecap}`;
            //             //Prepare form data
            //             // this.dataChoice[this.step.name] = this.choice.from.date;
            //         } else {
            //             const dataDayRecap = item.date
            //             const dataMonthRecap = item.month
            //             const dataYearRecap = item.year
            //             this.formattedDateRecapState = `${dataDayRecap} ${dataMonthRecap} ${dataYearRecap} - ` + this.choice.prettySlot
            //             //Prepare form data
            //             // this.dataChoice[this.step.name] = this.choice.value;
            //         }
            //         //Make choice as active
            //         this.choice.active = true;
            //         //Push in array the choice
            //         // this.arrayChoice[this.step.name] = this.formattedDateRecapState;
            //         //Prepare form data
            //         // this.dataChoice[this.step.name] = this.choice.from.date;
            //         //Get next step key
            //         this.nextStepKey = this.step.fieldsNextStep;
            //         //Go next step
            //         setTimeout(() => {
            //             this.prevSteps.push(this.step);
            //             this.nextStep();
            //         }, 200);
            //     } else {
            //         this.step = this.steps['availability']
            //         //Delete all infos after this step
            //         const targetName = this.step.name;
            //         const targetIndex = this.prevSteps.findIndex(obj => obj.name === targetName);
            //         this.prevSteps.splice(targetIndex);

            //         // let foundArrayChoice = false;
            //         // for (let key in this.arrayChoice) {
            //         //     if (foundArrayChoice) {
            //         //         delete this.arrayChoice[key];
            //         //     }
            //         //     if (key === targetName) {
            //         //         foundArrayChoice = true;
            //         //     }
            //         // }

            //         // let foundDataChoice = false;
            //         // for (let key in this.dataChoice) {
            //         //     if (foundDataChoice) {
            //         //         delete this.dataChoice[key];
            //         //     }
            //         //     if (key === targetName) {
            //         //         foundDataChoice = true;
            //         //     }
            //         // }
            //         //Active the field
            //         this.displayChoices = false
            //         this.displayFields = true
            //         //Get stepChoice object
            //         this.choice = slot;
            //         //Format for recap
            //         let date = new Date(this.choice.from.date);
            //         const dataDayRecap = date.toLocaleDateString('default', { day: '2-digit' });
            //         const dataMonthRecap = date.toLocaleDateString('default', { month: 'long' });
            //         const dataYearRecap = date.toLocaleDateString('default', { year: 'numeric' });
            //         const dataHourRecap = date.getHours().toString().padStart(2, '0');
            //         const dataMinutesRecap = date.getMinutes().toString().padStart(2, '0');
            //         this.formattedDateRecapState = `${dataDayRecap} ${dataMonthRecap} ${dataYearRecap} - ${dataHourRecap}:${dataMinutesRecap}`;
            //         //Make choice as active
            //         this.choice.active = true;
            //         //Push in array the choice
            //         // this.arrayChoice[this.step.name] = this.formattedDateRecapState;
            //         //Prepare form data
            //         // this.dataChoice[this.step.name] = this.choice.from.date;
            //         //Get next step key
            //         this.nextStepKey = this.step.fieldsNextStep;
            //         //Go next step
            //         setTimeout(() => {
            //             this.prevSteps.push(this.step);
            //             this.nextStep();
            //         }, 200);
            //     }
            // }
        },
        dateFormationFct() {
            const dataYear = this.currentDateState.toLocaleString('default', { year: 'numeric' });
            const dataMonth = this.currentDateState.toLocaleString('default', { month: '2-digit' });
            const dataDay = this.currentDateState.toLocaleString('default', { day: '2-digit' });
            this.formattedDate = `${dataYear}-${dataMonth}-${dataDay}`;
        },
        nextAvailabilitiesFct() {
            this.slotStepState = this.slotStepState + 1
            if (!this.shopCodeState) {
                this.shopCodeState = storeLocalShopCode
            }
            // Add seven days to currentDateState
            this.currentDateState.setDate(this.currentDateState.getDate() + this.limitState);
            // Add a page to currentPageState
            this.currentPageState = this.currentPageState + 1
            // Formatted current Date
            this.dateFormationFct();
            this.getAvailabilitiesFct();
        },
        previousAvailabilitiesFct() {
            if (this.slotStepState <= 0) {
                return;
            }
            this.slotStepState = this.slotStepState - 1
            if (!this.shopCodeState) {
                this.shopCodeState = storeLocalShopCode
            }
            // Remove seven days from currentDateState
            this.currentDateState.setDate(this.currentDateState.getDate() - this.limitState);
            // Remove a page from currentPageState
            this.currentPageState = this.currentPageState - 1
            // Formatted current Date
            this.dateFormationFct();
            this.getAvailabilitiesFct();
        },
    };

    return initMeetHoursLogic;
}

export default initMeetHoursComponent();
